
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Row, BaseText } from '@warrenbrasil/nebraska-web';
import { StatementAvatar } from '@/modules/transaction/components/StatementAvatar';

import { useDashStore } from '@/modules/common/store/DashModule';
import { HomeStatement, StatementDirection } from '@/modules/home/services/bff';

@Component({
  components: {
    BaseText,
    Row,
    StatementAvatar
  }
})
export default class StatementRow extends Vue {
  @Prop({ type: Object })
  readonly statement!: HomeStatement;

  private readonly dashModule = useDashStore();

  @Emit('on-statement-click')
  emitOnStatementClick() {
    return this.statement;
  }

  get computedValueClass() {
    return {
      'statement-row__value': true,
      'statement-row__text--ellipsis': true,
      'statement-row__value--positive':
        this.statement.direction === StatementDirection.CREDIT
    };
  }

  get shouldShowMoney() {
    return this.dashModule.showMoney;
  }
}
